/*
 * Nav current state, scroll half.
 *
 * The route half is decided in Liquid at render time and is not touched here.
 * This only moves the class between links that carry data-nav-anchor, which by
 * definition point at a section on this page.
 *
 * The rootMargin is what makes this feel right rather than technically correct.
 * With a plain observer every section that is even one pixel on screen counts as
 * visible, so on a long page two or three are lit at once and the state flickers
 * on every scroll. Shrinking the observation box to a band across the middle of
 * the viewport means a section only counts while it is the thing you are
 * actually looking at.
 *
 * Ships doing nothing if IntersectionObserver is missing, if the nav is absent,
 * or if no anchor target resolves. The nav still works, it just does not
 * highlight, which is the correct failure for a progressive enhancement.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var nav = document.querySelector('[data-peanut-nav]');
  if (!nav) return;

  var links = Array.prototype.slice.call(nav.querySelectorAll('[data-nav-anchor]'));
  if (!links.length) return;

  // Only keep links whose target actually exists on this page. A nav pointing at
  // a section someone removed should highlight nothing, not throw.
  var pairs = [];
  links.forEach(function (link) {
    var target = document.getElementById(link.getAttribute('data-nav-anchor'));
    if (target) pairs.push({ link: link, target: target });
  });
  if (!pairs.length) return;

  var onScreen = new Set();

  function apply() {
    // When the band holds more than one section, the higher one wins. Scrolling
    // down should light the next section as it arrives, not as it leaves.
    var winner = null;
    var winnerTop = Infinity;

    pairs.forEach(function (pair) {
      if (!onScreen.has(pair.target)) return;
      var top = pair.target.getBoundingClientRect().top;
      if (top < winnerTop) {
        winnerTop = top;
        winner = pair;
      }
    });

    pairs.forEach(function (pair) {
      var current = pair === winner;
      pair.link.classList.toggle('is-current', current);
      // aria-current is removed rather than set to false: a screen reader should
      // hear one current item or none, not four with three of them denied.
      if (current) {
        pair.link.setAttribute('aria-current', 'true');
      } else {
        pair.link.removeAttribute('aria-current');
      }
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) onScreen.add(entry.target);
        else onScreen.delete(entry.target);
      });
      apply();
    },
    { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
  );

  pairs.forEach(function (pair) {
    observer.observe(pair.target);
  });
})();
